module.exports = __webpack_public_path__ + "img/H2.bf9ba311.png";